import Drawer from 'react-modern-drawer';
import React, { useEffect, useState } from "react";
import ReportsServices from './ReportsServices';
import { CommonUtilities } from 'commonUtils';
import DeleteDialogueBox from 'components/Common/deleteDialogue';
import AddReporting_Transaction from './AddReportingTransaction';

export default function Reporting_transaction(param: any) {
    console.log(param);

    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [AddedTransactions, setAddedTransactions] = useState<any>([]);
    let [AddReportTransaction, setAddReportTransaction] = useState(false);

    const closeReportingTransaction = () => {
        param.closeReportingTransaction()
    }

    let Data = { pageNumber: 1, pageSize: 10, processReferenceId: '', manualReference: "", isActive: 1 };

    const getAddedTransactions = () => {

        console.log(param?.ExistingReferences?.filter((val: any) => val.processReferenceId == param?.selectedReference)[0])
        Data.manualReference = param?.ExistingReferences?.filter((val: any) => val.processReferenceId == param?.selectedReference)[0]?.manualReference;
        Data.processReferenceId = param?.selectedReference

        console.log(Data)
        ReportsServices.AddedTransactions(Data).then((res) => {
            setAddedTransactions(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
        });
    }

    useEffect(() => {
        getAddedTransactions()
    }, [param.ReportingTransactionOpen]);

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(deleteData)
        if (e == 1) {
            ReportsServices.deleteProcessReference(deleteData?.processReferenceId)
        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    const closeAddReportTransaction = () => {
        setAddReportTransaction(false)
    }

    return (
        <Drawer open={param.ReportingTransactionOpen} onClose={closeReportingTransaction} direction='right' >

            <div className="box noBorderRadius noBorder full-height-vh  pull-left ws-7">

                <div className="box-header-main">
                    <h2>Added Transaction</h2>
                </div>

                <div className="box-content pull-right">
                    <div className="form-format ws-12 mb">
                        <input type="text" placeholder="Filter" className='ws-8 height35' />
                        <button className="icon-btn edit caret lineHeight height35" onClick={() => getAddedTransactions()}><i className="icon-search"></i></button>
                        <button className="icon-btn edit caret lineHeight height35" onClick={() => setAddReportTransaction(true)}>Add Transaction</button>
                    </div>

                    <div className="ws-12 ">
                        <table className="newTable">
                            <thead>
                                <th></th>
                                <th>invoicenum</th>
                                <th>Headertype</th>
                                <th>Transactionref</th>
                                <th>Homevalue</th>
                                <th>Status</th>
                                <th>ManualReference</th>
                                <th>ExtendedStatus</th>
                                <th>invoiceDate</th>
                            </thead>

                            {
                                AddedTransactions.map((post: any, index: any) => {
                                    return (
                                        <tbody>

                                            <tr>
                                                <td><button className="icon-btn delete btn-xs" onClick={() => { setDeleteStatus(true); setDeleteData(post) }}><i className="icon-trashcan"></i></button></td>
                                                <td>{post.invoicenum}</td>
                                                <td>{post.headertype}</td>
                                                <td>{post.transactionref}</td>
                                                <td>{post.homevalue}</td>
                                                <td>{post.status}</td>
                                                <td>{post.manualReference}</td>
                                                <td>{post.extendedStatus}</td>
                                                <td>{post.invoiceDate}</td>
                                            </tr>

                                        </tbody>
                                    )
                                })}
                        </table>

                    </div>

                    <div className="box-footer ws-12">
                        <button className="icon-btn delete pull-right" onClick={closeReportingTransaction}> Close </button>
                    </div>

                </div>

                {(() => {

                    if (deleteStatus) {
                        return <DeleteDialogueBox param={deleteStatus} message={"to delete this reference"} onChange={deleteConfirmation} />
                    }

                    if (AddReportTransaction) {
                        return <AddReporting_Transaction closeAddReportTransaction={closeAddReportTransaction} AddReportTransaction={AddReportTransaction} data={param?.ExistingReferences[0]} />
                    }
                })()}

            </div>

        </Drawer>
    )
}